import React, { useState, useEffect, useCallback } from "react";
import Header from "../../layout/Header";
import "./VideosPage.css";
import SearchInput from "../../features/SearchInput";
import DatePickerInput from "../../features/DatePickerInput";
import { GetAllCandidates, GetVideo } from "../../../services/Videos";
import CandidatesCard from "../../features/CandidatesCard";
import ReactPaginate from "react-paginate";
import debounce from "debounce";
import { base64ToUint8Array } from "../../../Helpers/base64Transforms";
import Modal from "../../features/Modal";
import { UpdateCancelCandidate } from "../../../services/Candidates";
import { toast } from "react-toastify";
import { FFmpeg } from "@ffmpeg/ffmpeg";
import Loader from "../../../components/features/Loader";

const VideosPage = () => {
  const [blockDownloadButton, setBlockDownloadButton] = useState(true);
  const [blockSendButton, setBlockSendButton] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [newVideoReason, setNewVideoReason] = useState("");
  const [loaderData, setLoaderData] = useState({
    loading: false,
    message: "",
  });

  const [searchInput, setSearchInput] = useState("");
  const [parameters, setParameters] = useState({
    pageNumber: 1,
    pageSize: 20,
    searchCandidate: "",
    creationDate: null,
  });
  const [loadingMessage, setLoadingMessage] = useState("Loading Videos...");
  const [candidates, setCandidates] = useState([]);
  const [candidateSelected, setCandidateSelected] = useState({});

  const handleSelectedCandidates = (candidate) => {
    setCandidateSelected(candidate);
    setBlockDownloadButton(false);
  };

  const handleChangePage = (e) => {
    setParameters((prev) => (prev = { ...prev, pageNumber: e.selected + 1 }));
  };

  const searchData = (data) => {
    setParameters(
      (prev) => (prev = { ...prev, searchCandidate: data, pageNumber: 1 })
    );
  };

  const debounceSearch = useCallback(debounce(searchData, 500), []);

  const handleChangeSearchInput = (e) => {
    setSearchInput(e.target.value);
    debounceSearch(e.target.value);
  };

  const getCandidates = async (parameters) => {
    setBlockDownloadButton(true);
    setCandidateSelected({});
    setLoadingMessage("Loading Videos...");
    const data = await GetAllCandidates(parameters);
    if (
      data?.data?.length === 0 &&
      (parameters.searchCandidate.length > 0 || parameters.creationDate != null)
    ) {
      setLoadingMessage("No videos found for the selected filters");
    } else if (
      data?.data?.length === 0 &&
      parameters.searchCandidate.length === 0 &&
      parameters.creationDate == null
    ) {
      setLoadingMessage("No videos found ");
    }
    setCandidates(data);
  };

  const onChangeHandlerDate = (e) => {
    setParameters((prev) => (prev = { ...prev, creationDate: e.target.value }));
  };

  const handleClickSendReason = async () => {
    setLoaderData({
      loading: true,
      message: "Sending request",
    });
    const response = await UpdateCancelCandidate({
      id: candidateSelected.Id,
      cancellationReason: newVideoReason,
    });
    if (response.success) {
      getCandidates(parameters);
      setNewVideoReason("");
      setShowModal(false);
      setBlockSendButton(false);
    } else {
      setBlockSendButton(false);
      toast.error(response.errors[0]);
    }
    setLoaderData({
      loading: false,
      message: "",
    });
  };

  const onClickCandidateDownLoad = async () => {
    setLoaderData(
      (prev) =>
        (prev = {
          ...prev,
          loading: true,
          message: "Downloading video please wait",
        })
    );
    const videoName = candidateSelected.LinkUrl.split("/");
    const video = await GetVideo({ video: videoName[videoName.length - 1] });
    const ffmpeg = new FFmpeg({ log: true });
    await ffmpeg.load();
    if (video.success) {
      try {
        var blobvideo = base64ToUint8Array(video.data);
        await ffmpeg.writeFile("input.webm", blobvideo);
        // Ejecutar conversión
        await ffmpeg.exec([
          "-i",
          "input.webm",
          "-c:v",
          "mpeg4",
          "-q:v",
          "5",
          "-pix_fmt",
          "yuv420p",
          "-c:a",
          "libmp3lame",
          "-b:a",
          "128k",
          "output.avi",
        ]);
        const mp4Data = await ffmpeg.readFile("output.avi");
        const blob = new Blob([mp4Data.buffer], { type: "video/mp4" });
        const fileName = `${candidateSelected.FullName}.mp4`;
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setBlockDownloadButton(false);
      } catch (error) {
        toast.error(error);
        setBlockDownloadButton(false);
      }
    } else {
      toast.error(video.errors[0]);
      setBlockDownloadButton(false);
    }
    setLoaderData(
      (prev) =>
        (prev = {
          ...prev,
          loading: false,
          message: "",
        })
    );
  };

  useEffect(() => {
    setCandidates((prev) => (prev = { ...prev, data: [] }));
    getCandidates(parameters);
  }, [parameters]);

  return (
    <div>
      <Header showProfileButton={false} />
      <div className="video-title-container">
        <h1 className="">Hello Welcome to the Solvo´s Recruiter Portal</h1>
        <p>Let´s find the best talent together</p>
      </div>
      <div className="video-taskbar-container">
        <SearchInput
          value={searchInput}
          onHandleInput={handleChangeSearchInput}
          placeHolder="Search video by name or email address"
        />
        <DatePickerInput onHandleChange={onChangeHandlerDate} />
      </div>
      <div className="video-information-container">
        <div className="video-information-solverdata">
          <h3>Recently Sent Videos</h3>
          <div className="video-information-solverdata-list">
            {candidates?.data?.length > 0 ? (
              candidates?.data.map((x) => (
                <CandidatesCard
                  Email={x.emailUser}
                  FullName={x.fullName}
                  LinkUrl={x.fileLink}
                  Id={x.id}
                  creationDate={x.creationDate}
                  selected={candidateSelected.LinkUrl === x.fileLink}
                  onHandleClick={handleSelectedCandidates}
                />
              ))
            ) : (
              <div>{loadingMessage}</div>
            )}
          </div>
          <ReactPaginate
            className="video-information-paginator"
            breakLabel="..."
            nextLabel="next >"
            onPageChange={handleChangePage}
            pageRangeDisplayed={5}
            forcePage={
              candidates.hasOwnProperty("pageNumber")
                ? candidates?.pageNumber - 1
                : 0
            }
            pageCount={candidates?.totalPages}
            previousLabel="< previous"
            renderOnZeroPageCount={null}
          />
        </div>
        <div className="video-information-player-container">
          <h3>Soulver Video</h3>
          <div className="video-information-player-video">
            {Object.keys(candidateSelected).length > 0 ? (
              <video
                crossOrigin="anonymous"
                src={candidateSelected.LinkUrl}
                controls
              ></video>
            ) : (
              <div> Choose a video</div>
            )}
          </div>
          <div className="video-information-player-buttons">
            <button
              disabled={blockDownloadButton}
              onClick={() => {
                setBlockDownloadButton(true);
                return onClickCandidateDownLoad();
              }}
            >
              Download
            </button>
            <button
              disabled={blockDownloadButton}
              onClick={() => {
                return setShowModal(true);
              }}
            >
              Ask For New Video
            </button>
          </div>
        </div>
      </div>
      <Modal
        showModal={showModal}
        handleCloseClick={() => {
          setShowModal(false);
        }}
      >
        <div className="reason-modal-container">
          <div className="reason-modal-title">Reason For New Video</div>
          <div className="reason-modal-information">
            Please provide a reason for requesting a new video. This message
            will be sent to the candidate {candidateSelected.FullName} to help
            them understand why a new submission is needed and how to improve
            it. Example:
            <h5>
              "The video was blurry and the candidate’s voice was not audible.
              Please record a new video in a quiet environment and ensure good
              lighting.”
            </h5>
          </div>
          <textarea
            className="reason-modal-textarea"
            rows={4}
            value={newVideoReason}
            onChange={(e) => setNewVideoReason(e.target.value)}
          ></textarea>
          <button
            disabled={blockSendButton || !newVideoReason.length > 0}
            className="reason-modal-button"
            onClick={() => {
              setBlockSendButton(true);
              handleClickSendReason();
            }}
          >
            Send
          </button>
        </div>
      </Modal>
      <Loader show={loaderData.loading} message={loaderData.message} />
    </div>
  );
};

export default VideosPage;
